import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';

export default function HeldCopiesCount({ count }) {
  return (
    <div className="cp-held-copies-count">
      <FormattedMessage
        id={count === 1 ? 'held_copies_count' : 'held_copies_count_plural'}
        values={{ count }} />
    </div>
  );
}

HeldCopiesCount.propTypes = {
  count: PropTypes.number
};



// WEBPACK FOOTER //
// ./app/components/borrowing/checkouts/HeldCopiesCount/HeldCopiesCount.jsx